import { ReactElement } from 'react'

import { AdHocAccountProvider } from '../../../context/AdHocAccountContext'
import { AdHocParticipantProvider } from '../../../context/AdHocParticipantContext'
import { AdHocDecisionProvider } from '../../../context/AdHocDecisionContext'

interface AdHocParticipationProps {
  accountCommonId: string
  decisionId: string
  participationSessionId: string
  /** The raw link identifier from the URL (slug or session id); used to scope the participant cache. */
  linkId: string
  children: ReactElement
}
export function AdHocParticipationProviders({
  accountCommonId,
  decisionId,
  participationSessionId,
  linkId,
  children,
}: AdHocParticipationProps) {
  return (
    <AdHocAccountProvider accountCommonId={accountCommonId}>
      <AdHocParticipantProvider decisionId={decisionId} participationSessionId={participationSessionId} linkId={linkId}>
        <AdHocDecisionProvider decisionId={decisionId}>{children}</AdHocDecisionProvider>
      </AdHocParticipantProvider>
    </AdHocAccountProvider>
  )
}
